export const transformOptions = (options) => {
    return options
        .filter((x) => x.checked)
        ?.map((x) => x.label)
        .join(',');
};
